import { storeLogger } from 'ngrx-store-logger';

// Create reducer for logging
export function getLogger(): any[] {
    function logger(reducer: any): any {
        return storeLogger({ collapsed: true })(reducer);
    }

    // Only use the logger in the dev environment
    return process.env.YC_CODE_ENV === 'development' ? [logger] : [];
}
